/**
 * Created by toomasp on 01.02.2017.
 */

/** global utilities */
const debug = globalConfig.debug;

const NG_COMPONENT_FN_PATTERN = '.+\.(component|model|service|menu|filter)\.ts$';

// declares an intermediary module that contains no components/services/etc directly,
// just includes submodules from subdirectories and can optionally load the content of the submodule itself
export let ng1ParentModule = (ns: string, ctx, options?: { loadSubContents?: boolean, moduleNameOverride?: string, dependencies?: string[] }) => {
    let opts: { loadSubContents: boolean, dependencies: string[], moduleNameOverride?: string } = angular.extend(
        {loadSubContents: false, dependencies: ['eservice.core']},
        options || {}
    );

    let subModuleDirs = ctx.keys()
        .map(fn => fn.replace('./', ''))
        .filter(fn => fn.indexOf('/') > -1)
        .map(fn => fn.substring(0, fn.indexOf('/')))
        .reduce((arr, val) => {
            if (arr.indexOf(val) < 0) arr.push(val);
            return arr;
        }, []);

    // include each subModules' module file
    subModuleDirs.forEach(sub => {
        let subModulePrefix = './' + sub + '/';
        let subModuleFiles: string[] = ctx.keys()
            .filter(fn => fn.startsWith(subModulePrefix));

        let subModuleDeclFiles: string[] = subModuleFiles
            .filter(fn => {
                let subFn = fn.replace(subModulePrefix, '');
                if (subFn.indexOf('/') > -1) return false;
                return subFn.indexOf('.ts') > -1 && subFn.indexOf('.') == subFn.indexOf('.ts');
            });
        // load the module declaration files if any found
        subModuleDeclFiles.forEach(modDeclFn => {
            if (debug) console.log('Including module: ' + modDeclFn);
            ctx(modDeclFn);

            if (opts.loadSubContents) {
                subModuleFiles
                    .filter(subFn => subFn !== modDeclFn)
                    .filter(subFn => subFn.match(NG_COMPONENT_FN_PATTERN))
                    .forEach(subFn => {
                        if (debug) console.log('Including component/service: ' + subFn);
                        ctx(subFn);
                    });
            }
        });

        if (opts.loadSubContents && subModuleDeclFiles.length === 0) {
            ensureNg1Module(ns + "." + sub, opts.dependencies);// make sure the submodule actually gets declared
            // load submodule content files if module declaration file was not present
            subModuleFiles
                .filter(subFn => subFn.match(NG_COMPONENT_FN_PATTERN))
                .forEach(subFn => {
                    if (debug) console.log('Including component/service: ' + subFn);
                    ctx(subFn);
                });
        }
    });

    return angular.module(opts.moduleNameOverride || ns, subModuleDirs.map(dir => `${ns}.${dir}`));
};

export let ng1Module = (moduleName: string, moduleCtx, dependencies: string[] = ['eservice.core']): ng.IModule => {
    let ngModuleName = 'eservice.ui.' + moduleName;
    if (debug) console.log('Defining module: ' + ngModuleName);
    let mod = ensureNg1Module(ngModuleName, dependencies);
    moduleCtx.keys()
        .filter(subFn => {
            if (debug) console.log('Checking sub file for inclusion pattern: ' + subFn);
            return subFn.match(NG_COMPONENT_FN_PATTERN);
        })
        .forEach(subFn => {
            if (debug) console.log('Including component/service: ' + subFn);
            moduleCtx(subFn);
        });
    return mod;
};

export let ensureNg1Module = (ngModuleName: string, dependencies?: string[]): ng.IModule => {
    try {
        return angular.module(ngModuleName);
    } catch (e) {
        if (debug) console.log('Defining automatic module: ' + ngModuleName);
        return angular.module(ngModuleName, dependencies || ['eservice.core']);
    }
};



// WEBPACK FOOTER //
// ./src/ui/core/common/util/ng-helper.ts